<template>
  <Teleport to="body">
    <transition name="modal">
      <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
        <div class="modal-card animate-modal-enter">
          <button @click="$emit('close')" class="modal-close">&times;</button>

          <div class="modal-header">
            <h2 class="text-2xl md:text-3xl font-extrabold uppercase">Inscrição</h2>
            <p class="text-sm mt-1 opacity-75">5° Pedal no Paraíso 2026</p>
          </div>

          <form @submit.prevent="submitForm" class="modal-body">
            <div class="form-group">
              <label for="nome">Nome Completo</label>
              <input type="text" id="nome" v-model="nome" placeholder="Ex: José da Silva Campos" required @blur="validarNome" />
              <p v-if="nomeErro" class="text-xs mt-1" style="color:#E8652D">{{ nomeErro }}</p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="form-group">
                <label for="tel">Telefone</label>
                <input type="tel" id="tel" v-model="tel" pattern="[0-9]{11}" placeholder="21 999999999" required
                  oninput="this.setCustomValidity('')"
                  oninvalid="this.setCustomValidity('Telefone deve ter 11 dígitos')" />
              </div>
              <div class="form-group">
                <label for="email">E-mail</label>
                <input type="email" id="email" v-model="email" placeholder="seu@email.com" required />
              </div>
            </div>

            <div class="form-group">
              <label for="end">Endereço</label>
              <input type="text" id="end" v-model="end" placeholder="Seu endereço..." required />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="form-group">
                <label for="sexo">Sexo</label>
                <select id="sexo" v-model="sexo" required>
                  <option value="" disabled>Selecione</option>
                  <option value="masculino">Masculino</option>
                  <option value="feminino">Feminino</option>
                </select>
              </div>
              <div class="form-group">
                <label for="camisa">Camisa</label>
                <select id="camisa" v-model="camisa" required>
                  <option value="" disabled>Tamanho</option>
                  <option value="P">P</option>
                  <option value="M">M</option>
                  <option value="G">G</option>
                  <option value="GG">GG</option>
                </select>
                <p class="text-xs text-gray-400 mt-1">* Tamanhos sujeitos à disponibilidade de estoque</p>
              </div>
              <div class="form-group">
                <label for="local_retirada">Retirada do Kit</label>
                <select id="local_retirada" v-model="local_retirada" required>
                  <option value="" disabled>Local</option>
                  <option value="hotel_escola">Hotel Escola - Xerém</option>
                  <option value="caxias_shopping">Caxias Shopping</option>
                  <option value="vila_olimpica">Vila Olímpica</option>
                </select>
              </div>
            </div>

            <div class="form-group" v-if="sexo === 'feminino'">
              <label for="tipo_kit">Tipo de Kit</label>
              <select id="tipo_kit" v-model="tipo_kit" required>
                <option value="padrao">Kit Padrão</option>
                <option value="rosa">Kit Rosa (Especial Feminino)</option>
              </select>
              <p class="text-xs text-gray-400 mt-1">5 mil kits rosa disponíveis para as primeiras inscritas</p>
            </div>

            <p class="text-xs text-gray-500 mt-1">Retirada de 25 a 28 de abril, 8h às 17h — QR code + documento com foto</p>

            <button type="submit" class="btn-submit" :disabled="isLoading">
              {{ btSubmit }}
            </button>
          </form>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import axios from "axios";

export default {
  name: "Form",
  props: { show: Boolean },

  data() {
    return {
      isLoading: false,
      btSubmit: "INSCREVER-SE",
      nomeErro: "",
      nome: "",
      tel: "",
      end: "",
      camisa: "",
      sexo: "",
      tipo_kit: "padrao",
      local_retirada: "",
      email: "",
    };
  },

  watch: {
    sexo(val) {
      if (val !== 'feminino') {
        this.tipo_kit = 'padrao';
      }
    },
  },

  methods: {
    validarNome() {
      const partes = this.nome.trim().split(/\s+/);
      if (this.nome.trim() && partes.length < 2) {
        this.nomeErro = "Por favor, informe seu nome completo (nome e sobrenome).";
      } else {
        this.nomeErro = "";
      }
    },

    async submitForm() {
      this.validarNome();
      if (this.nomeErro) return;

      this.isLoading = true;
      this.btSubmit = "Enviando...";

      try {
        const response = await axios.post(
          "https://eventos.duquedecaxias.rj.gov.br/api/pedalparaiso/cadastro",
          {
            nome: this.nome,
            tel: this.tel,
            end: this.end,
            camisa: this.camisa,
            sexo: this.sexo,
            tipo_kit: this.sexo === 'feminino' ? this.tipo_kit : 'padrao',
            local_retirada: this.local_retirada,
            email: this.email,
          }
        );

        if (response.data.cod === 401) {
          this.$emit("close");
          this.$router.push("/pageExistente");
        } else if (response.data.cod === 402) {
          this.$emit("close");
          this.$router.push("/pageExistente2");
        } else if (response.data.cod === 403) {
          this.tipo_kit = "padrao";
          this.btSubmit = "INSCREVER-SE";
          this.isLoading = false;
          alert("Os kits rosa (especiais) esgotaram! Selecione o Kit Padrão e tente novamente.");
          return;
        } else {
          this.$emit("close");
          this.$router.push("/pageSucess");
        }
      } catch (e) {
        this.btSubmit = "INSCREVER-SE";
        this.isLoading = false;
        alert("Erro ao enviar inscrição. Tente novamente.");
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-card {
  background: white;
  border-radius: 1.5rem;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1.5rem;
  font-size: 2rem;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10;
  line-height: 1;
  transition: transform 0.2s;
}
.modal-close:hover { transform: scale(1.2); }

.modal-header {
  background: linear-gradient(135deg, #E8652D 0%, #D4A012 100%);
  color: white;
  padding: 2rem;
  border-radius: 1.5rem 1.5rem 0 0;
  text-align: center;
}

.modal-body {
  padding: 1.5rem 2rem 2rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #195493;
  margin-bottom: 0.3rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 0.75rem;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: #fafafa;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #E8652D;
  box-shadow: 0 0 0 3px rgba(232, 101, 45, 0.15);
}

.btn-submit {
  width: 100%;
  margin-top: 1.5rem;
  padding: 1rem;
  background: #E8652D;
  color: white;
  font-weight: 800;
  font-size: 1.1rem;
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: background 0.3s, transform 0.2s;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.btn-submit:hover { background: #c9521f; transform: translateY(-1px); }
.btn-submit:disabled { background: #ccc; cursor: not-allowed; transform: none; }

.modal-enter-active { transition: opacity 0.3s; }
.modal-leave-active { transition: opacity 0.2s; }
.modal-enter-from, .modal-leave-to { opacity: 0; }
</style>
